import Channel from '@/types/Channel.interface'
import Group from '@/types/Group.interface'
import moment from 'moment-timezone'
import Person from '@/types/Person.interface'
import User from '@/types/User.interface'
import Analytics from '@/services/Analytics'
export default {
    methods: {
        //  Remove from view
        removeFromBucket(): void {
            //  Set remove to true
            this.remove = true

            //  Call onBucketSelected to remove group
            this.onBucketSelected()
        },
        // Mark conversation(s) as new
        async markAsNew(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Get the required channelIds list
            const channel_ids = this.channelIds

            //  Additional props for our payload
            const additional = {
                unread_messages: 1,
                closed: null,
                open: moment.utc().format('YYYY-MM-DD HH:mm:ss')
            }

            const payload = {
                channel_ids: channel_ids,
                values: additional
            }

            //  Send our API request
            await this.$store.dispatch('channelsPutBatch', payload)

            //  Stop the loading spinner
            this.loading = false

            //  Publish the process completed event (this will reset the multi-selected items in iList, and reset the inbox filter)
            this.$emit('processCompleted')
        },
        // On view selected
        async onBucketSelected(group: Group): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            // Get the required channelIds list
            const channel_ids = this.channelIds

            // Get the group id
            const add_id = group ? group.id : null

            //  If remove is true, then remove id is the current group, else it is null
            const remove_id = this.remove ? this.currentGroup : null

            // Construct the view
            const response = await this.$store.dispatch('groupsPutBucketChannels', {
                channel_ids: channel_ids,
                add_id: add_id,
                remove_id: remove_id
            })

            //  Stop the loading spinner
            this.loading = false

            // If the response failed, return
            if (!response) return null

            //  Else, publish the process completed event (this will reset the multi-selected items in iList, and reset the inbox filter)
            this.$emit('processCompleted')

            // Navigate to the view that was assigned
            if (group) this.$router.push(`/i/g/${add_id}`)
            //  Else, refresh our current view
            else this.$store.dispatch('inboxChannelsPaginate')

            //  Refresh our inbox views
            this.$store.dispatch('groupsBucket')
        },
        // On user selected, assign channels to the user
        async onUserSelected(user: User): Promise<void> {
            // Set the loading data to true in parent (UX)
            this.$emit('setLoading', true)

            //  Construct our payload
            const payload = {
                channel_ids: this.channelIds,
                values: {
                    open: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                    closed: null,
                    assigned_id: user.id
                }
            }

            //  Start the loading spinner
            this.loading = true

            //  Send the request
            const resp = await this.$store.dispatch('channelsPutBatch', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the response was not successful, do nothing
            if (!resp) return

            //  Else, close the menu
            this.menu = false

            //  Publish the processCompleted event (this will reset the multi-selected items in iList)
            this.$emit('processCompleted')
        },
        //  Handle starting a broadcast from multiselect
        async startBroadcast(channel_ids: Channel[]): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send API request to get persons with matching channel ids
            const persons = await this.$store.dispatch('personsWhereInChannels', channel_ids)

            //  If the API response was not successful, do nothing
            if (!persons) return

            //  Construct new timestamped group
            const group = {
                name: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                persons_count: persons.length,
                persons_ids : persons.map((x: Person) => x.id)
            }

            //  Send API request to make group with these persons
            const response = await this.$store.dispatch('groupsPost', group)

            //  If the response was not successful, do nothing
            if (!response) return

            //  Stop the loading spinner
            this.loading = false

            //  Publish the process completed event (this will reset the multi-selected items in iList, and reset the inbox filter)
            this.$emit('processCompleted')

            //  Report to analytics
            Analytics.track('InboxSendBroadcastClicked')

            //  Route to broadcasts create with group id attached
            return this.$router.push(`/broadcasts/create?group=${response.id}`)
        },
        // Set stepper
        setStep(num: number): void {
            //  Change our step to the number passed in
            this.step = num
        }
    }
}